<template>
  <CRow>
    <CCol col="12" md="12" lg="12">
      <b-card header-tag="header" header-bg-variant="dark">
        <template #header>
          <p class="mb-0" style=""><strong>Rekap Gaji</strong></p>
        </template>
        <CRow>
          <CCol col="5">
            <b-form-group label="Tanggal Awal" label-for="tglPeriodeAwal" class="my-0">
              <date-picker class="my-0" id="tglPeriodeAwal" format="DD MMMM YYYY" style="width: 100%" v-model="filter.tglPeriodeAwal"></date-picker>
            </b-form-group>
          </CCol>
          <CCol col="5">
            <b-form-group label="Tanggal Akhir" label-for="tglPeriodeAkhir" class="my-0">
              <date-picker class="my-0" id="tglPeriodeAkhir" format="DD MMMM YYYY" style="width: 100%" v-model="filter.tglPeriodeAkhir"></date-picker>
            </b-form-group>
          </CCol>
          <!-- <CCol col="4">
            <b-form-group
              label="Cabang"
              label-for="cabang"
              class="my-0"
            >
              <Multiselect
                id="cabang"
                v-model="filter.cabang"
                :options="listCabang"
                :multiple="false"
                :searchable="true"
                :close-on-select="true"
                :show-labels="false"
                placeholder="-- Pilih Cabang --"
                label="namaCabang"
                track-by="cabangId"
              ></Multiselect>
            </b-form-group>
          </CCol> -->
          <CCol col="2" style="margin-bottom: 2px">
            <div class="w-100 h-100 d-flex align-items-end">
              <b-button variant="danger" style="" class="d-block w-100" v-c-tooltip.hover.click="'Reset'" @click="reset()">Reset</b-button>
            </div>
          </CCol>
          <CCol col="12" class="mt-1 mb-2"><hr /></CCol>
        </CRow>
        <CRow>
          <CCol>
            <CDataTable :items="items" :fields="fields" responsive sorter column-filter hover show-empty :loading="loading" @update:column-filter-value="onFilter($event)">
              <template #namaPeridoAwal-filter>
                <date-picker style="width: 100%" v-model="filter.peridoAwal" format="DD MMMM YYYY"></date-picker>
              </template>
              <template #namaPeridoAkhir-filter>
                <date-picker style="width: 100%" v-model="filter.peridoAkhir" format="DD MMMM YYYY"></date-picker>
              </template>
              <template #Actions="{ item }">
                <td>
                  <b-button variant="secondary" class="mr-1" v-c-tooltip.hover.click="'Print Data'" @click="print(item)"><CIcon name="cil-print" /></b-button>
                  <b-button variant="danger" class="mr-1" v-c-tooltip.hover.click="'Delete Data'" v-b-modal.modal-delete @click="openDeleteModal(item)">
                    <CIcon name="cil-trash" />
                  </b-button>
                </td>
              </template>
            </CDataTable>
            <MyPagination :entriesaw="entriesaw" :entriesak="entriesak" :totalRows="totalRows" :currentPage="currentPage" :perPage="perPage" @changeVar="changeVar" />
          </CCol>
        </CRow>
      </b-card>
    </CCol>
    <b-modal id="modal-delete" v-model="showDeleteModal" title="Konfirmasi Hapus" hide-footer centered>
      <div class="text-center">
        <p>Apakah Anda yakin ingin menghapus data rekap gaji ini?</p>
        <b-button variant="secondary" class="mr-2" @click="$bvModal.hide('modal-delete')"> Batal </b-button>

        <b-button variant="danger" @click="confirmDelete"> Hapus </b-button>
      </div>
    </b-modal>
  </CRow>
</template>

<script>
import { ipBackend } from "@/ipBackend";
import store from "@/store/store.js";

export default {
  components: {},
  name: "asuransi",
  data() {
    return {
      data: {},
      // listCabang: [],
      items: [],

      filter: {
        peridoAwal: null,
        peridoAkhir: null,
        tglPeriodeAwal: null,
        tglPeriodeAkhir: null,
        // cabang: null,
      },
      perPage: 10,
      totalRows: 0,
      currentPage: 1,
      loading: false,
      showDeleteModal: false,
      selectedDeleteItem: null,
    };
  },
  computed: {
    entriesaw() {
      return this.items.length != 0 && this.items ? this.items[0].no : 0;
    },
    entriesak() {
      return this.items.length != 0 && this.items ? this.items[this.items.length - 1].no : 0;
    },
    fields() {
      let x = [
        {
          key: "no",
          label: this.$store.state.table.no,
          sortDirection: "desc",
          _classes: "table-number text-center ",
          _style: "width: 1px;",
          filter: false,
          sorter: false,
        },
        {
          key: "namaKaryawan",
          label: this.$store.state.table.namaKaryawan,
          _style: "max-width: 30%;",
          sortDirection: "desc",
          _classes: "text-left",
          sorter: false,
        },
        {
          key: "namaPeridoAwal",
          label: this.$store.state.table.namaPeridoAwal,
          _style: "max-width: 20%;",
          sortDirection: "desc",
          _classes: "text-left",
          sorter: false,
        },
        {
          key: "namaPeridoAkhir",
          label: this.$store.state.table.namaPeridoAkhir,
          _style: "max-width: 20%;",
          sortDirection: "desc",
          _classes: "text-left",
          sorter: false,
        },
        {
          key: "namaTakeHomePay",
          label: this.$store.state.table.namaTakeHomePay,
          _style: "max-width: 15%;",
          sortDirection: "desc",
          _classes: "text-right",
          filter: false,
          sorter: false,
        },
        {
          key: "Actions",
          label: this.$store.state.table.Actions,
          _style: "width: 10%;",
          _classes: "table-option-2 text-center",
          filter: false,
          sorter: false,
        },
      ];
      if (this.$store.state.role_aktif.kodeRole == "super") {
        x.splice(1, 0, {
          key: "namaMitra",
          label: "Mitra",
          _style: "width: 10%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        });
      }
      return x;
    },
  },
  mounted() {
    // this.getDatas();
    // this.getCabang();
    this.reset();
  },
  watch: {
    currentPage(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    perPage(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    "filter.peridoAwal"(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    "filter.peridoAkhir"(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    "filter.tglPeriodeAwal"(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    "filter.tglPeriodeAkhir"(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    // 'filter.cabang'(newVal, oldVal) {
    //   if (newVal != oldVal) {
    //     this.getDatas();
    //   }
    // },
  },
  methods: {
    onFilter(x) {
      const vm = this;
      vm.filter = { ...vm.filter, ...x };
      vm.currentPage = 1;
      vm.getDatas();
    },
    openDeleteModal(item) {
      this.selectedDeleteItem = item;
      this.showDeleteModal = true;
    },
    async confirmDelete() {
      const vm = this;

      try {
        vm.loading = true;

        let res = await vm.$axios.post("rekapGaji/delete", {
          id: vm.selectedDeleteItem.rekapGajiId,
        });

        if (res.data.status == 200) {
          vm.$store.commit("set_alert", {
            type: "success",
            message: "Berhasil menghapus rekap gaji",
          });
          this.$bvModal.hide("modal-delete");
        } else {
          vm.$store.commit("set_alert", {
            type: "danger",
            message: "Gagal menghapus data",
          });
        }

        this.$bvModal.hide("modal-delete");
        vm.getDatas();
      } catch (err) {
        vm.$store.commit("set_alert", {
          type: "danger",
          message: "Terjadi kesalahan",
        });
      }
      this.$bvModal.hide("modal-delete");
      vm.loading = false;
    },
    async getDatas() {
      const vm = this;
      vm.loading = true;
      let listRekapGaji = await vm.$axios.post("rekapGaji/listPerHalaman", {
        ...vm.filter,
        //tabel
        peridoAwal: vm.filter.peridoAwal ? vm.$moment(vm.filter.peridoAwal).format("YYYY-MM-DD") : null,
        peridoAkhir: vm.filter.peridoAkhir ? vm.$moment(vm.filter.peridoAkhir).format("YYYY-MM-DD") : null,
        //header
        tglPeriodeAwal: vm.filter.tglPeriodeAwal ? vm.$moment(vm.filter.tglPeriodeAwal).format("YYYY-MM-DD") : null,
        tglPeriodeAkhir: vm.filter.tglPeriodeAkhir ? vm.$moment(vm.filter.tglPeriodeAkhir).format("YYYY-MM-DD") : null,
        // cabangId: vm.filter.cabang ? vm.filter.cabang.cabangId : null,
        halaman: vm.currentPage - 1,
        jumlah: vm.perPage,
      });
      // console.log("listRekapGaji", listRekapGaji);
      vm.items =
        listRekapGaji.data.status == 200
          ? listRekapGaji.data.data.map((x, idx) => {
              if (x.dataRekap.takeHomePay) {
                // console.log(idx, ' - ', x.namaCabang)
                x.takeHomePay = x.dataRekap.takeHomePay;
                x.namaTakeHomePay = vm.toNumeric(x.dataRekap.takeHomePay, "idr");
              } else {
                x.takeHomePay = 0;
                x.namaTakeHomePay = vm.toNumeric(0, "idr");
              }
              return {
                ...x,
                no: (vm.currentPage - 1) * vm.perPage + idx + 1,
                id: x.rekapGajiId,
                namaMitra: x.namaMitra || " - ",
                namaPeridoAwal: vm.$moment(x.peridoAwal).format("LL"),
                namaPeridoAkhir: vm.$moment(x.peridoAkhir).format("LL"),
              };
            })
          : [];
      vm.totalRows = parseInt(listRekapGaji.data.count);
      vm.loading = false;
    },
    // async getCabang() {
    //   let vm = this;
    //   let listCabang = await vm.$axios.get("cabang/list");
    //   vm.listCabang = listCabang.data.status == 200 ? listCabang.data.data : [];
    // },
    reset() {
      const vm = this;
      vm.filter.tanggal = new Date();
      vm.filter.tglPeriodeAwal = new Date(vm.$moment().startOf("month"));
      vm.filter.tglPeriodeAkhir = new Date(vm.$moment().endOf("month"));
      // vm.filter.cabang = vm.$store.state.cabang_aktif
    },
    print(data) {
      // console.log(data);
      let kode = store.state.kode_client ? store.state.kode_client : null;
      window.open(ipBackend + "api-" + kode + "/" + "downloadExcel/downloadSlipGaji/" + data.id, "_blank");
    },
    triggerAlert(event) {
      let vm = this;
      vm.$store.commit("set_alert", event);
      vm.getDatas();
    },
    toNumeric(number, type) {
      let data = {};
      if (type == "no-idr") {
        return new Intl.NumberFormat("id-ID", {
          style: "currency",
          currency: "IDR",
        })
          .format(number)
          .slice(3);
      } else {
        if (type == "idr") data = { style: "currency", currency: "IDR" };
        return new Intl.NumberFormat("id-ID", data).format(number);
      }
    },
    changeVar({ name, data }) {
      this[name] = data;
    },
  },
};
</script>
